module.exports = __webpack_public_path__ + "img/Loader.gif";